
const addresses = {
  rganft: "0x85cad4Cf034De01fC37d560e0A3279D56221bF1B",
  KOVAN_LINKTOKEN:	"0xa36085f69e2889c224210f603d836748e7dc0088",
    
};

export default addresses;
